@for (ctrl of boardUrls.controls; track $index) {
  <div class="provider-board-section__board-row">
    <mat-form-field appearance="fill" class="provider-board-section__field">
      <mat-label>{{ 'settings.integration.boardUrlLabel' | translate }}</mat-label>
      <input matInput [formControl]="ctrl" maxlength="500" />
      @if (ctrl.touched && ctrl.hasError('required')) {
        <mat-error>{{ 'settings.integration.boardUrlRequired' | translate }}</mat-error>
      }
      @if (ctrl.touched && ctrl.hasError('pattern')) {
        <mat-error>{{ 'settings.integration.boardUrlInvalid' | translate }}</mat-error>
      }
    </mat-form-field>

    <button
      mat-icon-button
      type="button"
      [attr.aria-label]="'settings.integration.testConnectionAriaLabel' | translate"
      [matTooltip]="'settings.integration.testTooltip' | translate"
      [disabled]="integrationIds()[$index] === null || isTesting()[$index]"
      (click)="testBoard.emit($index)"
    >
      @if (isTesting()[$index]) {
        <mat-progress-spinner diameter="20" mode="indeterminate"></mat-progress-spinner>
      } @else {
        <mat-icon aria-hidden="true">wifi_tethering</mat-icon>
      }
    </button>

    @if (testResults()[$index]?.success === true) {
      <span class="provider-board-section__badge provider-board-section__badge--success">
        <mat-icon aria-hidden="true">check_circle</mat-icon>
        {{ 'settings.integration.testBadgeSuccess' | translate }}
      </span>
    } @else if (testResults()[$index]?.success === false) {
      <span class="provider-board-section__badge provider-board-section__badge--error">
        <mat-icon aria-hidden="true">error</mat-icon>
        {{ 'settings.integration.testBadgeError' | translate }}
      </span>
    }

    @if (boardUrls.length > 1) {
      <button
        mat-icon-button
        type="button"
        [attr.aria-label]="'settings.integration.removeBoardAriaLabel' | translate"
        (click)="onRemoveClick($index)"
      >
        <mat-icon aria-hidden="true">close</mat-icon>
      </button>
    }
  </div>
}

@if (boardUrls.length < maxBoards) {
  <button mat-raised-button type="button" class="provider-board-section__add-board" (click)="addBoard.emit()">
    <mat-icon aria-hidden="true">add</mat-icon>
    {{ 'settings.integration.addBoard' | translate }}
  </button>
}

<lib-modal
  [title]="'settings.integration.removeBoardConfirm.title' | translate"
  [text]="'settings.integration.removeBoardConfirm.message' | translate"
  [visible]="pendingRemoveIndex() !== null"
  [saveText]="'settings.integration.removeBoardConfirm.confirm' | translate"
  [cancelText]="'settings.integration.removeBoardConfirm.cancel' | translate"
  (save)="onRemoveConfirmed()"
  (cancel)="onRemoveCancelled()"
  (visibleChange)="!$event && onRemoveCancelled()"
></lib-modal>
